import React, { useState } from 'react';
import axios from 'axios';
import { Button } from './ui/button';
import {
  DropdownMenu,
  DropdownMenuContent,
  DropdownMenuItem,
  DropdownMenuTrigger,
} from './ui/dropdown-menu';
import { Download, FileSpreadsheet, FileText } from 'lucide-react';
import { toast } from 'sonner';

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;

export const ExportButton = ({ resource, label = 'Exportar', testId }) => {
  const [loading, setLoading] = useState(false);

  const download = async (format) => {
    setLoading(true);
    try {
      const res = await axios.get(`${BACKEND_URL}/api/export/${resource}?format=${format}`, {
        withCredentials: true,
        responseType: 'blob',
      });
      const blob = new Blob([res.data]);
      const url = URL.createObjectURL(blob);
      const a = document.createElement('a');
      a.href = url;
      const date = new Date().toISOString().slice(0, 10).replace(/-/g, '');
      a.download = `${resource}_${date}.${format}`;
      document.body.appendChild(a);
      a.click();
      a.remove();
      URL.revokeObjectURL(url);
      toast.success('Exportação concluída');
    } catch (err) {
      toast.error('Erro ao exportar');
    } finally {
      setLoading(false);
    }
  };

  return (
    <DropdownMenu>
      <DropdownMenuTrigger asChild>
        <Button variant="outline" size="sm" disabled={loading} data-testid={testId || `export-${resource}-btn`}>
          <Download className="h-4 w-4 mr-2" />
          {loading ? 'Exportando...' : label}
        </Button>
      </DropdownMenuTrigger>
      <DropdownMenuContent align="end">
        <DropdownMenuItem onClick={() => download('csv')} data-testid={`export-${resource}-csv`}>
          <FileText className="h-4 w-4 mr-2" /> CSV
        </DropdownMenuItem>
        <DropdownMenuItem onClick={() => download('xlsx')} data-testid={`export-${resource}-xlsx`}>
          <FileSpreadsheet className="h-4 w-4 mr-2" /> Excel (.xlsx)
        </DropdownMenuItem>
      </DropdownMenuContent>
    </DropdownMenu>
  );
};
